// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2x9dh","text":"SelectPayment_text__19YFN","title":"SelectPayment_title___Tt0f","btn":"SelectPayment_btn__1MU8h"};